import React, { useState } from 'react';

const DemoGuide = ({ scenario, onCopyQuery }) => {
  const [expandedIdx, setExpandedIdx] = useState(null);
  const [copiedIdx, setCopiedIdx] = useState(null);

  if (!scenario || !scenario.demoQuestions || scenario.demoQuestions.length === 0) {
    return null;
  }

  const handleCopy = (q, idx) => {
    navigator.clipboard.writeText(q).then(() => {
      setCopiedIdx(idx);
      setTimeout(() => setCopiedIdx(null), 1500);
    });
    if (onCopyQuery) onCopyQuery(q);
  };

  return (
    <div style={{
      borderTop: '1px solid #e0e0e0',
      marginTop: 12,
      paddingTop: 12,
      flexShrink: 0,
      maxHeight: 280,
      overflowY: 'auto',
    }}>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        marginBottom: 10,
      }}>
        <span style={{
          fontSize: 12,
          fontWeight: 700,
          color: '#1976d2',
          textTransform: 'uppercase',
          letterSpacing: 0.5,
        }}>
          Demo Guide — {scenario.title}
        </span>
        <span style={{
          fontSize: 10,
          color: '#999',
          fontStyle: 'italic',
        }}>
          Click a question to copy & paste into chat
        </span>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
        {scenario.demoQuestions.map((item, idx) => {
          const isExpanded = expandedIdx === idx;
          const isCopied = copiedIdx === idx;

          return (
            <div
              key={idx}
              style={{
                border: '1px solid #e0e0e0',
                borderRadius: 6,
                overflow: 'hidden',
                backgroundColor: isCopied ? '#e8f5e9' : '#fafafa',
                transition: 'background-color 0.3s',
              }}
            >
              {/* Question row */}
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                padding: '8px 10px',
                cursor: 'pointer',
              }}
                onClick={() => setExpandedIdx(isExpanded ? null : idx)}
              >
                <span style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: 20,
                  height: 20,
                  borderRadius: '50%',
                  backgroundColor: '#1976d2',
                  color: 'white',
                  fontSize: 11,
                  fontWeight: 700,
                  flexShrink: 0,
                }}>
                  {idx + 1}
                </span>

                <span style={{
                  flex: 1,
                  fontSize: 13,
                  fontWeight: 500,
                  color: '#333',
                  lineHeight: 1.4,
                }}>
                  {item.q}
                </span>

                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    handleCopy(item.q, idx);
                  }}
                  style={{
                    padding: '4px 10px',
                    fontSize: 11,
                    fontWeight: 600,
                    border: 'none',
                    borderRadius: 4,
                    cursor: 'pointer',
                    flexShrink: 0,
                    backgroundColor: isCopied ? '#4caf50' : '#1976d2',
                    color: 'white',
                    transition: 'background-color 0.2s',
                  }}
                >
                  {isCopied ? '✓ Copied' : 'Copy'}
                </button>
              </div>

              {/* Talking points + expected highlights (collapsible) */}
              {isExpanded && (
                <div style={{
                  padding: '6px 10px 10px 38px',
                  borderTop: '1px solid #eee',
                  backgroundColor: '#f5f8ff',
                }}>
                  {item.talkingPoints && (
                    <div style={{
                      fontSize: 12,
                      color: '#1976d2',
                      fontStyle: 'italic',
                      lineHeight: 1.5,
                      marginBottom: 8,
                      padding: '4px 8px',
                      backgroundColor: '#e3f2fd',
                      borderRadius: 4,
                    }}>
                      💡 {item.talkingPoints}
                    </div>
                  )}
                  {item.expectedHighlights && (
                    <>
                      <div style={{
                        fontSize: 10,
                        fontWeight: 600,
                        color: '#666',
                        textTransform: 'uppercase',
                        marginBottom: 4,
                        letterSpacing: 0.3,
                      }}>
                        What to highlight in the answer:
                      </div>
                      {item.expectedHighlights.map((h, hIdx) => (
                        <div key={hIdx} style={{
                          display: 'flex',
                          alignItems: 'flex-start',
                          gap: 6,
                          fontSize: 12,
                          color: '#555',
                          lineHeight: 1.5,
                          padding: '2px 0',
                        }}>
                          <span style={{ color: '#4caf50', fontWeight: 700, flexShrink: 0 }}>→</span>
                          <span>{h}</span>
                        </div>
                      ))}
                    </>
                  )}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default DemoGuide;
